import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const line = {
  hidden: { y: "115%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 0.85, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

// Kopfbereich für Unterseiten – ruhig, klar, mit maskiertem Titel-Reveal.
export default function SubpageHero({ eyebrow, titleLines = [], intro, accent = "text-brand-green", testId }) {
  return (
    <section
      data-testid={testId}
      className="relative pt-36 md:pt-44 pb-6 md:pb-10"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          <Link
            to="/"
            data-testid="back-home"
            className="inline-flex items-center gap-2 text-ink-muted hover:text-brand-green transition-colors font-semibold"
          >
            <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
          </Link>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mt-8 font-accent text-3xl md:text-4xl text-brand-pink -rotate-1"
        >
          {eyebrow}
        </motion.p>

        <h1 className="mt-2 font-heading font-extrabold tracking-tight text-ink text-4xl md:text-6xl lg:text-7xl leading-[1.03]">
          {titleLines.map((l, i) => (
            <span key={i} className="block overflow-hidden">
              <motion.span
                variants={line}
                custom={i}
                initial="hidden"
                animate="show"
                className={`block ${i === titleLines.length - 1 ? accent : ""}`}
              >
                {l}
              </motion.span>
            </span>
          ))}
        </h1>

        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.6 }}
            className="mt-6 max-w-2xl text-lg md:text-xl leading-relaxed text-ink-muted"
          >
            {intro}
          </motion.p>
        )}
      </div>
    </section>
  );
}
